import { render } from "./Quadruple.vue?vue&type=template&id=0cd7db14&scoped=true&ts=true"
import script from "./Quadruple.vue?vue&type=script&lang=ts"
export * from "./Quadruple.vue?vue&type=script&lang=ts"

import "./Quadruple.vue?vue&type=style&index=0&id=0cd7db14&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd7db14"]])

export default __exports__